import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { ClientService } from "./client.service";
import { EmailService } from "./email.service"; 
import { SearchResult } from "../models/search-result.model";
import { PetTagListModel, InvPetListModel } from "../models/pet-tag-list.model";
import { PetModel } from "../models/pet.model";
import { InvoiceTransModel } from "../models/invoice-trans.model";
import { TmpInvoiceTransModel } from "../models/invoice-trans.model";
import { ClinicRabiesCodeModel } from "../models/clinic-rabies-code.model";
import { PetToInvoiceModel } from "../models/invoice-model";
import { PaymentDetailsModel } from "../models/invoice-model";
import { TempPrescModel } from "../models/invoice-model";
import { InvHistoryModel } from "../models/invoice-history.model";
import { PetAssociateModel } from "../models/pet-associate.model";
import { PetInvoiceListModel } from "../models/invoice-compiled.model";
import { FinanceCRModel } from "../models/finance.model";
import { InvoiceReceiptModel } from "../models/invoice-receipt.model";
import { CatalogService } from '../services/catalog.service';
import { ProcedureService } from '../services/procedure.service';
import { DeleteATranModel } from "../models/delete-a-tran.model";
import { TranRecordModel } from "../models/tran-record.model";
import { PaymentServiceModel } from "../models/payment-service.model";
import { encode_base64, encode_utf8 } from '../../environments/environment';
import { PetNoteModel, NoteModel } from "../models/pet-note.model";
import { CityLicenseModel } from "../models/city-license.model";
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { RabiesVaccineModel } from "../models/rabies-vaccine.model";

interface NotificationPayload {
    origin: any;
    pet_no: any;
}

@Injectable({
    providedIn: "root"
})
export class InvoiceService {

    private baseUrl: string = 'invoice';
    // userData: any = JSON.parse(localStorage['currentUser']);  
    // clinic: any = JSON.parse(localStorage['clinic']);  

    invpetlist: InvPetListModel[] = []
    invoice_trans: InvoiceTransModel[] = []
    clinic_rabies_code: ClinicRabiesCodeModel[] = []
    pet_data: PetModel = new PetModel(0, 0, '', '', 0, '', '', '', '', '', 0, 0, '', '', '', '', '', 0, 0, 0, '', false, 0, '', '', '', '', 0, 0, '', 0, '', false);
    pet_to_invoice_list: PetToInvoiceModel[] = []
    payment_Details: PaymentDetailsModel = new PaymentDetailsModel(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)
    payment_Details_list: PaymentDetailsModel[] = []
    inv_history: InvHistoryModel = new InvHistoryModel(0, 0, 0, 0, 0, '', '', '', 0, 0, 0, 0, '', '', 0, 0, 0, 0, '', 0, '', 0)
    temp_presc: TempPrescModel = new TempPrescModel(0, 0, '', '', '', 0, '', 0, '', false, '', false, '')
    tmp_invoice_trans: TmpInvoiceTransModel[] = []
    pet_associates: PetAssociateModel[] = [];
    currentpet_priorbalance: number = 0.00;
    currentClient_Nonprofit: boolean = false;
    finance_cr: FinanceCRModel[] = [];
    clientfinance_cr: FinanceCRModel[] = [];
    payment_service: PaymentServiceModel = new PaymentServiceModel('', '', 0);
    pet_note: PetNoteModel = new PetNoteModel(0, '', 0, 0, '', '', '');
    note: NoteModel = new NoteModel(0, 0, '', '', '', [], false);
    cityLicense: CityLicenseModel[] = [];

    activeRabiesVaccine: RabiesVaccineModel[] = [];
    selectedActiveRabiesVaccine: RabiesVaccineModel = new RabiesVaccineModel('', '', '', '', false, '');


    pet_invoice_listModel: PetInvoiceListModel[] = []
    compiled_PetINV: {
        pet_no: number,
        pet_name: string,
        alertResult: string,
        notesResult: string,
        ToBeInvoiced: boolean,
        TaxAmt: number,
        Amount: number,
        notesDetails: any,
        alertDetails: any,
        procsDetails: { done: any, undone: any },
        procsDetailsStr: string,
        rabiesDets: any,
        neuterDets: any,
        currentBalance: number,
        PetDeposit: number
    }[] = [];
    tax_rate: number = 0

    //from payment reg.
    payment_forms: any[] = []
    inv_otherdata: {
        client_no: number,
        lngInvNo: number,
        clinic_no: number,
        inv_date: string,
    } = {
            client_no: 0,
            lngInvNo: 0,
            clinic_no: 0,
            inv_date: this.getCurrentDateTime(),
        };
    assocother_forPetFinance: any = []
    toBeDeletedItems: {
        pet_no: number,
        pet_name: string,
        sub_appt_id: number | null,
        appointment_id: number | null,
        tag_no: string | null,
        has_visit: boolean,
        has_hospital_instr: boolean,
        has_alert: boolean,
        selectedTag: boolean,
        selectedAppt: boolean,
        selectedInstr: boolean,
        selectedAlert: boolean,
        selectedVisit: boolean
    }[] = [] // to be deleted items after invoice
    emailInvReciept:boolean = false


    constructor(
        private api: ApiService,
        private catalogService: CatalogService,
        private procedureService: ProcedureService,
        private clientService: ClientService,
        private emailService:EmailService,
    ) {
    }

    private notifyPayReg = new Subject<void>();
    notifyPayRegObservable = this.notifyPayReg.asObservable();
    notifyPayRegFunction() {
        this.notifyPayReg.next();
    }

    private notifyInvReceipt = new Subject<void>();
    notifyInvReceiptObservable = this.notifyInvReceipt.asObservable();
    notifyInvReceiptFunction() {
        this.notifyInvReceipt.next();
    }


    private notify_InvSoloModal = new Subject<NotificationPayload>();
    notify_InvSoloModalObservable = this.notify_InvSoloModal.asObservable();
    notify_InvSoloModalFunction(origin: any, pet_no: any) {
        this.notify_InvSoloModal.next({ origin, pet_no });
    }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    }

    get clinic(): any {
        return JSON.parse(localStorage['clinic']);
    }

    get clinicDetails(): any {
        return JSON.parse(localStorage.getItem('clinic') || '{}').find(x => x.clinic_no == this.userData.clinic_no)?.clinic_type || 0;
    }

    get activeClinicDetails(): any {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        const clinics = JSON.parse(localStorage.getItem('clinic') || '[]');
        return clinics.find((c: any) => c.clinic_no == currentUser.clinic_no) || null;
    }


    GetInvPetTransByClientNo(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInvPetTransByClientNo?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.invpetlist = res.data.map((element) => {
                            return new InvPetListModel('', element.pet_no, element.pet_name);
                        });
                        resolve(1);
                    } else {
                        this.invpetlist = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetInvAlertsByPetNo(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInvAlertsByPetNo?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    GetInvNotesByPetNo(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInvNotesByPetNo?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    GetCurrentBalance(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetCurrentBalance?client_no=${client_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    GetTaxRate(clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetTaxRate?clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    GetInvPetInfoNotes(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInvPetInfoNotes?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    const result = res.data.map((element: any) => ({
                        notetype: element.notetype,
                        notetext: element.notetext
                    }));
                    resolve(result);
                });
        });
        return promise;
    }

    GetInvPetInfoProcs(pet_no: number, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInvPetInfoProcs?pet_no=${pet_no}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    const result = res.data.map((element: any) => ({
                        code_name: element.code_name,
                        item_desc: element.item_desc,
                        link_no: element.link_no,
                        link_type: element.link_type,
                        status: element.status,
                        cost: element.cost,
                        done_date: element.done_date,
                        req_date: element.req_date,
                        location: element.location,
                        response1: element.response1,
                        response2: element.response2
                    }));
                    resolve(result);
                });
        });
        return promise;
    }

    GetRabieTagNo(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetRabieTagNo?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    GetInvoiceTrans(client_no: number, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInvoiceTrans?client_no=${client_no}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.invoice_trans = res.data.map((element) => {
                            return new InvoiceTransModel(
                                element.tran_sequence,
                                element.sup_sequence,
                                element.client_no,
                                element.pet_no,
                                element.link_no,
                                element.link_type,
                                element.code_name,
                                element.item_type,
                                element.unit,
                                element.req_date,
                                element.appr_date,
                                element.done_date,
                                element.req_by,
                                element.Req_employee_initial,
                                element.done_by,
                                element.employee_initial,
                                element.appr_by,
                                element.status,
                                element.pstatus,
                                element.tax,
                                element.response1,
                                element.response2,
                                element.cost,
                                element.route,
                                element.printed,
                                element.moved,
                                element.code_clinic,
                                element.location
                            );
                        });

                        resolve(1);
                    } else {
                        this.invoice_trans = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetClinicRabiesCode(clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClinicRabiesCode?clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.clinic_rabies_code = res.data.map((element) => {
                            return new ClinicRabiesCodeModel(element.link_no, element.link_type, element.code_name);
                        });
                        resolve(1);
                    } else {
                        this.clinic_rabies_code = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupTempPetRabie(rabie_tag_no: string, rabie_clinic: number, pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupTempPetRabie?rabie_tag_no=${rabie_tag_no}&rabie_clinic=${rabie_clinic}&pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetPetNeuter(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetPetNeuter?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    GetInvPetInfoAlert(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInvPetInfoAlert?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    const result = res.data.map((element: any) => ({
                        alert_code: element.alert_code,
                        alert_description: element.alert_description,
                        alert_category: element.alert_category,
                        date_field: element.date_field,
                        date_field_code: element.date_field_code
                    }));
                    resolve(result);
                });
        });
        return promise;
    }

    GetInvPetBriefHistory(date_field_code: string, pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInvPetBriefHistory?date_field_code=${date_field_code}&pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    const result = res.data.map((element: any) => ({
                        brief_hist_date: element.brief_hist_date,
                        brief_hist_code: element.brief_hist_code,
                        brief_hist_resp1: element.brief_hist_resp1,
                        brief_hist_resp2: element.brief_hist_resp2,
                        done_in_clinic: element.done_in_clinic
                    }));
                    resolve(result);
                });
        });
        return promise;
    }

    GetInvPetHistory(code_name: string, pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInvPetHistory?code_name=${code_name}&pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    GetInvPetData(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInvPetData?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    const result = new PetModel(res.data.pet_no, 0, '', res.data.pet_name, res.data.weight, res.data.sex, res.data.dob, res.data.neuter, res.data.rabieDate, res.data.active, res.data.temperature, res.data.height, res.data.pet_code, res.data.picture, res.data.breed_name, res.data.color_name, res.data.specie_name, res.data.breed, res.data.color, res.data.specie, res.data.tag_no, false, res.data.age, res.data.blood_pressure, res.data.rabies, res.data.chip_no, res.data.assigned_doctor, res.data.body_score, res.data.alt_breed, res.alt_breed_name, res.alt_color, res.alt_color_name, res.data.deceased);
                    resolve(res);
                });
        });
        return promise;
    }

    InsertCashReg(client_no: number, cashreg_clinic: number, cashreg_date: string, amount_of_pay: number, method_of_pay: number, check_card: string,
        cashier: string, cashreg_station: number, cashreg_check: string, invoice_no: number, pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/InsertCashReg?client_no=${client_no}&cashreg_clinic=${cashreg_clinic}&cashreg_date=${cashreg_date}&amount_of_pay=${amount_of_pay}&method_of_pay=${method_of_pay}&check_card=${check_card}&cashier=${cashier}&cashreg_station=${cashreg_station}&cashreg_check=${cashreg_check}&invoice_no=${invoice_no}&pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetMaxNo_InvoiceNo() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetMaxNo_InvoiceNo`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    GetPetBalance(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetPetBalance?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    getCurrentDateTime() {
        const currentDate = new Date();

        const year = currentDate.getFullYear();
        const month = ('0' + (currentDate.getMonth() + 1)).slice(-2); // Month is 0-indexed
        const day = ('0' + currentDate.getDate()).slice(-2);
        const hours = ('0' + currentDate.getHours()).slice(-2);
        const minutes = ('0' + currentDate.getMinutes()).slice(-2);
        const seconds = ('0' + currentDate.getSeconds()).slice(-2);

        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.000`;
        return formattedDate;
    }

    getCurrentDate() {
        const currentDate = new Date();

        const year = currentDate.getFullYear();
        const month = ('0' + (currentDate.getMonth() + 1)).slice(-2); // Month is 0-indexed
        const day = ('0' + currentDate.getDate()).slice(-2);

        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    getCurrentDateTimeAMPM() {
        const currentDate = new Date();
        const year = currentDate.getFullYear().toString(); // Get the last two digits of the year
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Add 1 to the month because it is zero-based
        const day = currentDate.getDate().toString().padStart(2, '0');
        const hours = currentDate.getHours();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
        const minutes = currentDate.getMinutes().toString().padStart(2, '0');
        const seconds = currentDate.getSeconds().toString().padStart(2, '0');

        return `${month}/${day}/${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
    }

    UpdateSequencer() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateSequencer`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }


    SaveRespNote(pet_no: number[], trans_seq: number[], LinkName: string[]) {
        const requestBody = {
            pet_no: pet_no,
            trans_seq: trans_seq,
            LinkName: LinkName,
        };

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SaveRespNote`, requestBody)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });

        return promise;
    }

    GetCheckRecalls(pet_no_list: string, recall_date: string) {
        const encodedPetNumbers = encodeURIComponent(pet_no_list);
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetCheckRecalls?pet_no_list=${pet_no_list}&recall_date=${recall_date}`)
                .subscribe((res: any) => {
                    const result = res.data.map((element: any) => ({
                        pet_no: element.pet_no,
                        pet_name: element.pet_name,
                        recall_date: element.recall_date,
                        recall_sequence: element.recall_sequence,
                        recall_proc1: element.recall_proc1,
                        recall_proc2: element.recall_proc2,
                        recall_proc3: element.recall_proc3
                    }));
                    resolve(result);
                });
        });
        return promise;
    }

    SetupInvRecalls(status_date: string, recall_sequence: number, pet_no: number, recall_log_date: string, recall_by: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupInvRecalls?status_date=${status_date}&recall_sequence=${recall_sequence}&pet_no=${pet_no}&recall_log_date=${recall_log_date}&recall_by=${recall_by}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupInvHistory() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupInvHistory`, this.inv_history)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    UpdateTransMoved(tran_sequence: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateTransMoved?tran_sequence=${tran_sequence}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    UpdateEuthToInactive(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateEuthToInactive?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetBriefHistoryCategory(code_no: number, code_type: number, code_clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetBriefHistoryCategory?code_no=${code_no}&code_type=${code_type}&code_clinic=${code_clinic}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    UpdateBriefHist(pet_no: number, code_no: number, code_type: number, code_clinic: number, client_no: number, brief_hist_code: string,
        brief_hist_date: string, brief_hist_resp1: string, brief_hist_resp2: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateBriefHist?pet_no=${pet_no}&code_no=${code_no}&code_type=${code_type}&code_clinic=${code_clinic}&client_no=${client_no}&brief_hist_code=${brief_hist_code}&brief_hist_date=${brief_hist_date}&brief_hist_resp1=${brief_hist_resp1}&brief_hist_resp2=${brief_hist_resp2}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetTempPrescBySeq(transact_sequence: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetTempPrescBySeq?transact_sequence=${transact_sequence}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.temp_presc = new TempPrescModel(0, res.data.pet_no, res.data.presc_date, res.data.product_name, res.data.doctor, res.data.units, res.data.package,
                            res.data.refill_count, res.data.refill_expire, res.data.allow_generic, res.data.instructions, res.data.in_clinic, res.data.use_for);
                        resolve(this.temp_presc);
                    } else {
                        this.temp_presc = new TempPrescModel(0, 0, '', '', '', 0, '', 0, '', false, '', false, '');
                        resolve(this.temp_presc);
                    }
                });
        });
        return promise;
    }

    SetupMoveToDrugNote(tran_sequence: number, done_date: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupMoveToDrugNote?tran_sequence=${tran_sequence}&done_date=${done_date}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    InsertToDrugNote(pet_no: number, drug_note_date: string, product_name: string, doctor: number, units: number, ipackage: string,
        refill_count: number, refill_expire: string, allow_generic: boolean, instructions: string, in_clinic: boolean, use_for: string, history_unit: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/InsertToDrugNote?pet_no=${pet_no}&drug_note_date=${drug_note_date}&product_name=${product_name}&doctor=${doctor}&units=${units}&package=${ipackage}&refill_count=${refill_count}&refill_expire=${refill_expire}&allow_generic=${allow_generic}&instructions=${instructions}&in_clinic=${in_clinic}&use_for=${use_for}&history_unit=${history_unit}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetTmpInvoiceTrans(sup_sequence: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetTmpInvoiceTrans?sup_sequence=${sup_sequence}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.tmp_invoice_trans = res.data.map((element) => {
                            return new TmpInvoiceTransModel(
                                element.tran_sequence, element.sup_sequence, element.pet_no, element.client_no, element.link_no, element.link_type, element.unit, element.req_date, element.appr_date, element.done_date, element.req_by, element.appr_by, element.done_by, element.pstatus, element.response1, element.response2, element.cost, element.route, element.location, element.supervisor, element.status
                            );
                        });

                        resolve(1);
                    } else {
                        this.tmp_invoice_trans = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetInvSubTran(transact_sequence: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInvSubTran?transact_sequence=${transact_sequence}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    InsertSubTran(history_sequence: number, link_no: number, link_type: number, unit: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/InsertSubTran?history_sequence=${history_sequence}&link_no=${link_no}&link_type=${link_type}&unit=${unit}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetItemCategory(code_no: number, code_type: number, code_clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetItemCategory?code_no=${code_no}&code_type=${code_type}&code_clinic=${code_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        resolve(res.data);
                    } else {
                        resolve('');
                    }
                });
        });
        return promise;
    }

    InsertLabTran(history_sequence: number, pet_no: number, clinic_no: number, done_date: string, link_no: number, link_type: number, appr_by: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/InsertLabTran?history_sequence=${history_sequence}&pet_no=${pet_no}&clinic_no=${clinic_no}&done_date=${done_date}&link_no=${link_no}&link_type=${link_type}&appr_by=${appr_by}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    MoveToSuggested(pet_no: number, suggest_date: string, link_no: number, link_type: number, tran_sequence: number, notedate: string, notetext: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/MoveToSuggested?pet_no=${pet_no}&suggest_date=${suggest_date}&link_no=${link_no}&link_type=${link_type}&tran_sequence=${tran_sequence}&notedate=${notedate}&notetext=${notetext}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupPetFinance(pet_no: number, client_no: number, current_balance: number, promised_amount: number, deposit: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupPetFinance?pet_no=${pet_no}&client_no=${client_no}&current_balance=${current_balance}&promised_amount=${promised_amount}&deposit=${deposit}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getAssociateByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`pet/getAssociateByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        const result = res.data.map((element: any) => ({
                            pet_no: element.pet_no,
                            last_name: element.last_name,
                            first_name: element.first_name,
                            middle_initial: element.middle_initial,
                            associate_no: element.associate_no,
                            authority_id: element.authority_id,
                            authority_desc: element.authority_desc,
                            associate_ownership: element.associate_ownership
                        }));
                        resolve(result);
                    }
                });
        });
        return promise;
    }

    getAssociateByClientId(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`invoice/getAssociateByClientId?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        const result = res.data.map((element: any) => ({
                            pet_no: element.pet_no,
                            last_name: element.last_name,
                            first_name: element.first_name,
                            middle_initial: element.middle_initial,
                            associate_no: element.associate_no,
                            authority_id: element.authority_id,
                            authority_desc: element.authority_desc,
                            associate_ownership: element.associate_ownership
                        }));
                        resolve(result);
                    }
                });
        });
        return promise;
    }

    GetClientPriorBalance(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClientPriorBalance?client_no=${client_no}`)
                .subscribe((res: any) => {
                    this.currentpet_priorbalance = res.data
                    resolve(res.data);
                });
        });
        return promise;
    }

    GetClientNonprofit(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClientNonprofit?client_no=${client_no}`)
                .subscribe((res: any) => {
                    this.currentClient_Nonprofit = res.data
                    resolve(1);
                });
        });
        return promise;
    }


    GetPetAmount(pet_no: number, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetPetAmount?pet_no=${pet_no}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    GetCompiledInvoiceList(client_no: number, clinic_no: number, pet_no: number) {
        this.pet_invoice_listModel = [];
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetCompiledInvoiceList?client_no=${client_no}&clinic_no=${clinic_no}&pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        let s_pet_invoice_listModel = res.data.map((element) => {
                            return new PetInvoiceListModel(element.pet_no, element.pet_name, element.Procs, element.Notes, element.Alerts, element.Rabies, element.Neuter, element.PetBal, element.PetDeposit);
                        });
                        resolve(s_pet_invoice_listModel);
                    } else {
                        let s_pet_invoice_listModel = [new PetInvoiceListModel(0, '', [], '', '', 0, 0, 0.00, 0.00)];
                        resolve(s_pet_invoice_listModel);
                    }
                });
        });
        return promise;
    }

    GetPetInvReport(pet_no: number, start_date: string, end_date: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetPetInvReport?pet_no=${pet_no}&start_date=${start_date}&end_date=${end_date}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.finance_cr = res.data.map((element) => {
                            return new FinanceCRModel(element.inv_date, element.invoice_no, element.pet_no, element.actual_charge, element.total_charge, element.Discount, element.total_tax, element.prior_balance, element.balance_due, element.amount_paid, element.coupon, element.clinic_account, element.change, element.current_balance, element.deposit, element.ownership, element.payment_methods, '', element.file_id);
                        });
                        resolve(1);
                    } else {
                        this.finance_cr = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetClientInvReport(client_no: number, start_date: string, end_date: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClientInvReport?client_no=${client_no}&start_date=${start_date}&end_date=${end_date}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.clientfinance_cr = res.data.map((element) => {
                            return new FinanceCRModel(element.inv_date, element.invoice_no, element.pet_no, element.actual_charge, element.total_charge, element.Discount, element.total_tax, element.prior_balance, element.balance_due, element.amount_paid, element.coupon, element.clinic_account, element.change, element.current_balance, element.deposit, element.ownership, element.payment_methods, element.pet_name, element.file_id);
                        });
                        resolve(1);
                    } else {
                        this.clientfinance_cr = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    CheckTempPetRabie(pet_no: number, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/CheckTempPetRabie?pet_no=${pet_no}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupMoveRabInfo(pet_no: number, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupMoveRabInfo?pet_no=${pet_no}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupDeposit(client_no: number, clinic_no: number, clinic_type: number, pet_no: number, amount: number, method_of_pay: number, cashier: string, check_card: string, station: number, user_no: number) {
        //https://localhost:5001/api/invoice/SetupDeposit?client_no=44936&clinic_no=1&clinic_type=3&pet_no=67687&amount=3&method_of_pay=1&cashier=tdm&check_card=NULL&station=1&user_no=290
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupDeposit?client_no=${client_no}&clinic_no=${clinic_no}&clinic_type=${clinic_type}&pet_no=${pet_no}&amount=${amount}&method_of_pay=${method_of_pay}&cashier=${cashier}&check_card=${check_card}&station=${station}&user_no=${user_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    //SetupCreateRabCert(int pet_no, int clinic_no, bool reprint = false)
    SetupCreateRabCert(pet_no: number, clinic_no: number, reprint: boolean = false) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupCreateRabCert?pet_no=${pet_no}&clinic_no=${clinic_no}&reprint=${reprint}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(res.data);
                    }
                });
        });
        return promise;
    }

    GetActiveRabiesVaccine() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetActiveRabiesVaccine?clinic_no=${this.userData.clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.activeRabiesVaccine = res.data.map((element) => {
                            return new RabiesVaccineModel(element.vaccine_manuf, element.vaccine_type, element.vaccine_expire, element.vaccine_name, element.vaccine_active, element.vaccine_use);
                        });
                        resolve(res.data);
                    }
                });
        });
        return promise;
    }







    //INVOICING FUNCTIONS
    AddToCashReg() {
        this.payment_forms.forEach((items) => {
            this.InsertCashReg(this.inv_otherdata.client_no, this.inv_otherdata.clinic_no, this.getCurrentDateTime(), items.amount, items.method, items.method_dets,
                items.receiver, 1, '', this.inv_otherdata.lngInvNo, items.pet_no)
        })

        //Discount
        if (this.payment_Details.Discount != 0) {
            this.payment_Details_list.forEach((item) => {
                this.InsertCashReg(this.inv_otherdata.client_no, this.inv_otherdata.clinic_no, this.getCurrentDateTime(), item.Discount, 12, 'discount',
                    '', 1, '', this.inv_otherdata.lngInvNo, item.pet_no)
            })
        }

        //add current balance to pet finance 
        this.payment_Details_list.find((pet) => {
            if (Math.sign(pet.current_balance) == -1) {
                this.SetupPetFinance(pet.pet_no, this.inv_otherdata.client_no, 0, 0, pet.current_balance * -1)
            }
            else {
                this.SetupPetFinance(pet.pet_no, this.inv_otherdata.client_no, pet.current_balance, 0, 0)
            }
        })


        this.assocother_forPetFinance.forEach((item) => {
            this.SetupPetFinance(item.pet_no, item.client_no, parseFloat(item.balance.toFixed(2)), 0, 0)
        })

    }

    SetupInvoiceReceipt(receiptdata: InvoiceReceiptModel) {
        const requestBody = {
            id: receiptdata.id,
            invoice_no: receiptdata.invoice_no,
            transactions: JSON.stringify(receiptdata.transactions),
            payment_dets: JSON.stringify(receiptdata.payment_dets),
            pet_no: receiptdata.pet_no,
            client_no: receiptdata.client_no,
            inv_date: receiptdata.inv_date,
            client_signature: receiptdata.client_signature,
            file_id: String(receiptdata.file_id ?? '')
        };

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupInvoiceReceipt`, requestBody)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });

        return promise;
    }

    //DELETE TRANSACTIONS
    async DeleteTran() {
        let vinvoice_trans_T = []
        let parsedProcs: any[] = []; // Initialize as empty array

        this.pet_invoice_listModel.forEach(async (compiledItem) => {
            this.pet_to_invoice_list.forEach((checkitem) => {
                if (compiledItem.pet_no == checkitem.pet_no) {
                    try {
                        let parsedItem = JSON.parse((compiledItem.Procs).toString());
                        parsedProcs.push(...parsedItem);
                    } catch (error) {
                        console.error('Error parsing Procs field:', error); // Handle any parsing errors
                    }

                }
            })
        })

        parsedProcs.forEach((trans_item) => {
            if (trans_item.status === 'D' || trans_item.status === 'S' || trans_item.status === 'F' || trans_item.status === 'O') {
                const trans_item_index = parsedProcs.findIndex((item) => item === trans_item);
                this.DeleteATran(this.invtrans_formatter(parsedProcs), trans_item_index, this.invoice_trans.length, parsedProcs);
            }
            else if (trans_item.status === 'T' || trans_item.status === 'R' || trans_item.status === 'S' || trans_item.status === 'Q' || trans_item.status === 'C') {
                vinvoice_trans_T.push(trans_item);
            }
        })

        return vinvoice_trans_T
    }

    async DeleteTranDialog(item) {
        return Swal.fire({
            title: 'Treatment Request Found',
            text: 'Delete ' + item.code_name + ' treatment  request(s) for this pet (' + item.pet_no + ')?',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel'
        });
    }

    DeleteATran(trans, intIndex, intTotalIdx, trans_unformatted?) {
        this.PutIntoHistory(trans_unformatted)
        this.procedureService.deleteATran(new DeleteATranModel(trans, intIndex, intTotalIdx, false, '', 1, 0, false)).then(() => { });
    }

    invtrans_formatter(trans: any): TranRecordModel[] {
        let transArray: any[] = Array.isArray(trans) ? trans : [trans];
        let toReturn: TranRecordModel[] = [];

        transArray.forEach(element => {
            let t: TranRecordModel = new TranRecordModel();

            t.Seq = element.tran_sequence;
            t.SupSeq = element.sup_sequence
            t.PetNo = element.pet_no
            t.ClientNo = element.client_no
            t.ClinicNo = Number(element.clinic_no ?? 0);
            t.LinkNo = element.link_no
            t.LinkType = element.link_type
            t.LinkName = element.link_name
            t.LinkDesc = element.link_desc
            t.LinkFix = element.item_type
            t.Unit = Number(element.unit)
            t.UnitCost = Number(element.unit_cost)
            t.ReqDate = element.req_date || '0001-01-01T00:00:00'
            t.ReqBy = element.req_by != null ? Number(element.req_by) : null
            t.ReqName = element.req_employee_initial
            t.ApproveDate = element.appr_date
            t.ApproveBy = element.appr_by != null ? Number(element.appr_by) : null
            t.ApproveName = element.appr_employee_initial
            t.DoneDate = element.done_date
            t.DoneBy = element.done_by != null ? Number(element.done_by) : null
            t.DoneName = element.done_employee_initial
            t.InvDate = element.inv_date
            t.InvBy = element.inv_by != null ? Number(element.inv_by) : null
            t.InvName = element.inv_employee_initial
            t.Status = element.status
            t.PStatus = element.pstatus === 'True' ? true : false
            t.Tax = Number(element.tax)
            t.Response1 = element.response1
            t.Response2 = element.response2
            t.Approval = element.approval
            t.CheckCost = element.chk_cost
            t.Cost = Number(element.cost)
            t.SubCost = Number(element.sub_cost ?? 0);
            t.IType = element.item_type
            t.Route = element.route
            t.Printed = Boolean(Number(element.printed))
            t.WTime = element.wtime
            t.Moved = Boolean(Number(element.moved))
            t.RecallDate = element.recall_date || null
            t.IsOptional = element.optional != null ? Boolean(Number(element.optional)) : null
            t.IsRerequest = element.rerequest
            t.Supervisor = element.supervisor
            t.Attending = element.attending
            t.Location = element.location
            t.BaseChg = element.basechg

            toReturn.push(t);
        });

        return toReturn;
    }
    //DELETE TRANSACTIONS








    //Functions from Invoicing tranfer here for Pet Ribbon access
    async getTransDetails(proclist): Promise<any[]> {
        let parsedProcs2;

        try {
            parsedProcs2 = JSON.parse(proclist);
        } catch (error) {
            console.error('Error parsing Procs:', error);
        }

        let toReturn = [{
            vToBeInvoiced: true,
            vTaxAmt: 0,
            vAmount: 0
        }]

        console.log('parsedProcs2', parsedProcs2)

        if (Array.isArray(parsedProcs2)) {
            parsedProcs2.forEach((trans_item) => {
                let sglTax = 0;
                if (trans_item.status == 'D' || trans_item.status == 'F' || trans_item.status == 'O') {
                    // if (trans_item.sup_sequence == 0) {
                    sglTax = trans_item.cost * this.tax_rate * trans_item.tax
                    console.log('pet:', trans_item.pet_no, 'sglTax:', sglTax, '| trans_item.cost:', trans_item.cost, '| this.tax_rate:', this.tax_rate, '| trans_item.tax:', trans_item.tax)
                    toReturn[0].vTaxAmt += sglTax;
                    toReturn[0].vAmount += trans_item.cost;
                    // }
                }
                else if (trans_item.status == 'T' || trans_item.status == 'S' || trans_item.status == 'Q') {
                    if (!(trans_item.link_no === 0 && trans_item.link_type === 0)) {
                        toReturn[0].vToBeInvoiced = false
                    }
                }
            });
        } else {
            console.error('proclist is not an array:', proclist);
        }


        return toReturn
    }

    async DisplayToTable(petInv_list): Promise<any> {
        this.compiled_PetINV = [];
        this.pet_invoice_listModel = petInv_list;
        await Promise.all(petInv_list.map(async (item) => {
            let transDetails = [{
                vToBeInvoiced: true,
                vTaxAmt: 0,
                vAmount: 0
            }];

            if (item.Procs) {
                transDetails = await this.getTransDetails(item.Procs);
            }

            this.compiled_PetINV.push({
                pet_no: item.pet_no,
                pet_name: item.pet_name,
                alertResult: '',
                notesResult: '',
                ToBeInvoiced: transDetails[0].vToBeInvoiced,
                TaxAmt: transDetails[0].vTaxAmt,
                Amount: transDetails[0].vAmount,
                notesDetails: item.Notes ? await this.gettblcol_notes_array(item.Notes) : [],
                alertDetails: item.Alerts ? await this.gettblcol_alert_array(item.Alerts) : [],

                //procsDetails: await this.gettblcol_procs(transDetails[0].vToBeInvoiced,item.Procs),
                procsDetails: item.Procs ? await this.gettblcol_procs_array(transDetails[0].vToBeInvoiced, item.Procs) : [],
                procsDetailsStr: item.Procs ? await this.gettblcol_procs(transDetails[0].vToBeInvoiced, item.Procs) : '',
                rabiesDets: item.Rabies,
                neuterDets: item.Neuter,
                // rabiesDets: item.Procs ? await this.checkRabies(item.Procs,item.pet_no, this.userData.clinic_no) : null,
                currentBalance: item.PetBal,
                PetDeposit: item.PetDeposit
            })
        }))
        return this.compiled_PetINV
    }

    async gettblcol_procs(tobeinvoice, proclist): Promise<string> {
        let parsedProcs1;

        try {
            parsedProcs1 = JSON.parse(proclist);
        } catch (error) {
            console.error('Error parsing Procs:', error);
        }

        let toReturn = '';

        let txtDoneProcs = "<b>Patient completed procedures:</b> <br>"
        let txtUnfProcs = ""
        let blnDone = false
        if (tobeinvoice == true) {
            txtUnfProcs = "<b>No unfinished procedures.</b> <br>"
        }
        else {
            txtUnfProcs = "<b>Has the following unfinished procedures:</b> <br>"
        }

        parsedProcs1.forEach(async (item) => {
            if (item.status === "D" || item.status === "F" || item.status === "O") {
                txtDoneProcs += this.formatDatetime(item.done_date) + ' -- '
                if (item.status === 'O') {
                    if (item.code_name === 'ONLINE') {
                        txtDoneProcs += item.location
                    }
                    else if (item.response1 === 'online') {
                        txtDoneProcs += item.response1 + '/' + item.response2
                    }
                }
                else {
                    txtDoneProcs += this.getProcDesc(item.link_no)
                }
                txtDoneProcs += ' ( ' + item.code_name + ' ) -- $' + item.cost + '<br>'
                blnDone = true
            }
            else if (item.status !== "T") {
                txtUnfProcs += this.formatDatetime(item.req_date) + ' -- ' + this.getProcDesc(item.link_no) + ' ( ' + item.code_name + ' ) -- ' + item.status + '<br>';
            }
        });

        if (!blnDone) {
            txtDoneProcs = '<b>This patient has no completed procedures.</b><br>'
        }

        toReturn = txtDoneProcs + txtUnfProcs
        return toReturn
    }

    async gettblcol_procs_array(tobeinvoice, proclist): Promise<any> {
        let parsedProcs1;
        let txtDoneProcs = []
        let txtUnDoneProcs = []

        try {
            parsedProcs1 = JSON.parse(proclist);
        } catch (error) {
            console.error('Error parsing Procs:', error);
        }

        parsedProcs1.forEach(async (item) => {
            if (item.status === "D" || item.status === "F" || item.status === "O") {
                let item_desc = ''
                if (item.status === 'O') {
                    if (item.code_name === 'ONLINE') {
                        item_desc += item.location
                    }
                    else if (item.response1 === 'online') {
                        item_desc += item.response1 + '/' + item.response2
                    }
                }
                else {
                    item_desc += this.getProcDesc(item.link_no)
                }
                item_desc += ' ( ' + item.code_name + ' )'

                txtDoneProcs.push({ date: this.formatDatetime(item.done_date), desc: item_desc, amount: item.cost, type: 'D', tran_sequence: item.tran_sequence, status: item.status, link_no: item.link_no, code_name: item.code_name })
            }
            else if (item.status !== "T") {
                let t_type = (tobeinvoice) ? 'N' : 'U'
                txtUnDoneProcs.push({ date: this.formatDatetime(item.req_date), desc: this.getProcDesc(item.link_no), amount: item.cost, type: t_type, tran_sequence: item.tran_sequence, status: item.status, link_no: item.link_no, code_name: item.code_name })
            }
        });

        // let combinedArray: any[] = txtDoneProcs.concat(txtUnDoneProcs);
        let combinedArray = { done: txtDoneProcs, undone: txtUnDoneProcs }
        return combinedArray;
    }

    async gettblcol_notes_array(noteslist): Promise<any> {
        let parsedNotes1;
        let txtNotes = []
        try {
            parsedNotes1 = JSON.parse(noteslist);
        } catch (error) {
            console.error('Error parsing Notes:', error);
        }

        parsedNotes1.forEach(async (item) => {
            let note_type = this.catalogService.note_type.find((note) => note.notetype == item.notetype);
            txtNotes.push({ notetype: note_type?.notename, notetext: item.notetext })
        })

        return txtNotes;
    }

    async gettblcol_alert_array(alertlist): Promise<any> {
        // tblPetAlert.alert_code,
        // alert_description,
        // alert_category,
        // date_field,
        // date_field_code
        let parsedAlerts1;
        let txtAlerts = []
        try {
            parsedAlerts1 = JSON.parse(alertlist);
        } catch (error) {
            console.error('Error parsing Alert:', error);
        }

        parsedAlerts1.forEach(async (item) => {
            txtAlerts.push({ alert_code: item.alert_code, alert_description: item.alert_description, alert_category: item.alert_category, date_field: item.date_field, date_field_code: item.date_field_code })
        })
        return txtAlerts;
    }

    getProcDesc(code) {
        const cat_procs = this.catalogService.codes_file.find((proc) => proc.procedure_no == code)
        return cat_procs ? cat_procs.procedure_desc : '';
    }

    async checkRabies(proclist, pet_no, clinic_no) {
        let parsedProcs3;
        let iCheckRabies = -1
        let blnFound = false;

        try {
            parsedProcs3 = JSON.parse(proclist);
        } catch (error) {
            console.error('Error parsing Procs:', error);
        }

        await this.api.get<SearchResult>(`${this.baseUrl}/CheckTempPetRabie?pet_no=${pet_no}&clinic_no=${clinic_no}`).subscribe((res: any) => {
            if (res.data) {
                iCheckRabies = 0
                return iCheckRabies
            }
        })

        await this.api.get<SearchResult>(`${this.baseUrl}/CheckNeuter?pet_no=${pet_no}`).subscribe((res: any) => {
            if (!res.data) {
                return iCheckRabies
            }
        })

        await parsedProcs3.forEach((trans_item) => {
            this.clinic_rabies_code.forEach((rabie_item) => {

                if (trans_item.link_no == rabie_item.link_no && trans_item.link_type == rabie_item.link_type) {
                    if (trans_item.status !== 'S' && trans_item.status !== 'F') {
                        blnFound = true;
                    }
                }
            });
        });

        if (!blnFound) {
            await this.api.get<SearchResult>(`${this.baseUrl}/CheckSubTransaction?pet_no=${pet_no}&clinic_no=${clinic_no}`).subscribe((res: any) => {
                if (res.data > 0) {
                    blnFound = true
                }
            })
        }

        if (blnFound) {
            return 0
        }


        return iCheckRabies;
    }

    GetCityLicense(clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetCityLicense?clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.cityLicense = res.data.map((element) => {
                            return new CityLicenseModel(element.link_no, element.cert_name, element.cert_cost);
                        });
                        resolve(res.data);
                    }
                });
        });
        return promise;
    }

    UpdateRabiesTagNo(pet_no: number, rabies_tag_no: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateRabiesTagNo?pet_no=${pet_no}&rabies_tag_no=${rabies_tag_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(res.data);
                    }
                });
        });
        return promise;
    }

    UpdatePetNeuter(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdatePetNeuter?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(res.data);
                    }
                });
        });
        return promise;
    }

    // Call backend endpoint and return raw data array (no typed model)
    GetDataAfterInvoice(invoice_no: number, appt_date: string): Promise<any[]> {
        let promise = new Promise<any[]>((resolve, reject) => {
            const url = `${this.baseUrl}/GetDataAfterInvoice?invoice_no=${invoice_no}&appt_date=${encodeURIComponent(appt_date)}`;
            this.api.get<any>(url)
                .subscribe((res: any) => {
                    if (res && res.results > 0 && Array.isArray(res.data)) {
                        resolve(res.data);
                    } else {
                        resolve([]);
                    }
                }, (err) => {
                    reject(err);
                });
        });
        return promise;
    }

    DeleteDataAfterInvoice(pet_no: number, date: string, client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/DeleteDataAfterInvoice?pet_no=${pet_no}&date=${date}&client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }




    //convert timestamp to dateformat MM/DD/YYYY HH:MM AM/PM
    formatDatetime(timestamp: string): string {
        const date = new Date(timestamp);
        const options: any = {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true // Use 12-hour clock with AM/PM
        };
        return date.toLocaleString('en-US', options);
    }

    // #region Online payment 

    CreateInvoiceLink() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/CreateInvoiceLink`, this.payment_service)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    CreateAndSendInvoice() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/CreateAndSendInvoice`, this.payment_service)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    // #endregion

    //#region Invoice Receipts

    Print_PetInvListModel: {
        pet_no: number,
        pet_name: string,
        tag_no: string,
        trans: any[],
        sugg: any[],
        pay: any[],
        totalcharge: number,
        tax: number,
        priorBal: number,
        amountpaid: number,
        remainingBal: number,
        ownership: number,
    }[] = []

    async saveInvoiceReceiptInfo(): Promise<number> {
        try {
            this.Print_PetInvListModel = []

            this.pet_invoice_listModel.forEach(async (compiledItem) => {
                this.pet_to_invoice_list.forEach(async (checkitem) => {

                    if (compiledItem.pet_no == checkitem.pet_no) {
                        let sTrans = []
                        let sSugg = []
                        let sPay = []

                        let parsedProcs: any[]; // Define a variable to store the parsed JSON array

                        try {
                            parsedProcs = JSON.parse((compiledItem.Procs).toString()); // Parse the Procs string into a JSON array
                        } catch (error) {
                            console.error('Error parsing Procs field:', error); // Handle any parsing errors
                        }

                        parsedProcs?.forEach(trans_item => {
                            if (trans_item.sup_sequence == 0 && trans_item.status == 'D' || trans_item.status == 'F' || trans_item.status == 'O') {
                                sTrans.push({
                                    pet_no: trans_item.pet_no,
                                    done_date: trans_item.done_date,
                                    link_no: trans_item.link_no,
                                    code_name: trans_item.code_name,
                                    procDesc: this.getProcDesc(trans_item.link_no),
                                    response1: trans_item.response1,
                                    response2: trans_item.response2,
                                    cost: trans_item.cost,
                                    tran_sequence: trans_item.tran_sequence,
                                })
                            }
                            else if ((trans_item.sup_sequence == 0 && trans_item.printed != false) && (trans_item.status == 'D' || trans_item.status == 'F')) {
                                sTrans.push({
                                    pet_no: trans_item.pet_no,
                                    done_date: trans_item.done_date,
                                    link_no: trans_item.link_no,
                                    code_name: trans_item.code_name,
                                    procDesc: '  * ' + this.getProcDesc(trans_item.link_no),
                                    response1: trans_item.response1,
                                    response2: trans_item.response2,
                                    cost: trans_item.cost,
                                    tran_sequence: trans_item.tran_sequence,
                                })
                            }
                            if (trans_item.status == 'S') {
                                sSugg.push({
                                    pet_no: trans_item.pet_no,
                                    done_date: trans_item.done_date,
                                    link_no: trans_item.link_no,
                                    code_name: trans_item.code_name,
                                    procDesc: this.getProcDesc(trans_item.link_no),
                                    response1: trans_item.response1,
                                    response2: trans_item.response2,
                                    cost: trans_item.cost,
                                    tran_sequence: trans_item.tran_sequence,
                                })
                            }
                        })//Get Transaction

                        sPay.push(this.payment_Details_list.find(pays => pays.pet_no == compiledItem.pet_no))

                        let PaymentInfo = this.getPaymentInfo(compiledItem.pet_no)

                        this.Print_PetInvListModel.push({
                            pet_no: compiledItem.pet_no,
                            pet_name: compiledItem.pet_name,
                            tag_no: '0',
                            trans: sTrans,
                            sugg: sSugg,
                            pay: sPay,
                            totalcharge: PaymentInfo.total_charge,
                            tax: PaymentInfo.total_tax,
                            priorBal: PaymentInfo.prior_balance,
                            amountpaid: PaymentInfo.amount_paid,
                            remainingBal: PaymentInfo.current_balance,
                            ownership: PaymentInfo.ownership,
                        })

                        let s_otherdatainv = this.inv_otherdata;
                        let receiptdata: InvoiceReceiptModel = new InvoiceReceiptModel(0, s_otherdatainv.lngInvNo, sTrans, sPay, compiledItem.pet_no, s_otherdatainv.client_no, s_otherdatainv.inv_date, this.clientService.client_signature, 0);

                        // collect receipts to setup and process later so we print once for all pets
                        if (!Array.isArray((<any>this)._receiptsToSetup)) {
                            (<any>this)._receiptsToSetup = [];
                            (<any>this)._processedPetsForReceipt = [];
                        }
                        (<any>this)._receiptsToSetup.push(receiptdata);
                        (<any>this)._processedPetsForReceipt.push({ pet_no: compiledItem.pet_no, receiptdata });

                    }
                })
            })

            // After collecting all receipt entries, call backend to create them, then print once
            const receiptsToSetup: InvoiceReceiptModel[] = (<any>this)._receiptsToSetup || [];
            const processedPets: { pet_no: number, receiptdata: InvoiceReceiptModel }[] = (<any>this)._processedPetsForReceipt || [];

            if (receiptsToSetup.length > 0) {
                // ensure all receipts created in backend
                await Promise.all(receiptsToSetup.map(r => this.SetupInvoiceReceipt(r)));

                // print once for the invoice (all pets)
                const fileId: number = await this.printInvoiceReceipt(this.userData.clinic_no, this.inv_otherdata.client_no, this.inv_otherdata.lngInvNo) as number;

                // update invoice with generated file id
                this.updateInvoiceReceiptFileId(this.inv_otherdata.lngInvNo, fileId);

                // create pet notes for each processed pet using the single fileId
                for (const entry of processedPets) {
                    const rd = entry.receiptdata;
                    const note_text = `Client #${rd.client_no} paid $${rd.payment_dets[0].amount_paid} for Bella with an ownership percentage of ${rd.payment_dets[0].ownership}% under (Invoice ID: ${rd.invoice_no}). -- ${this.userData.employee_name}`;
                    await this.creupPetNote(entry.pet_no, note_text, 7);
                    this.note = new NoteModel(
                        0,
                        entry.pet_no,
                        '',
                        null,
                        '[file:' + fileId + '] - ' + note_text,
                        [41]);
                    await this.setupNote();
                    this.note = new NoteModel(0, 0, '', null, '', []);
                }

                // clear temporary arrays
                (<any>this)._receiptsToSetup = [];
                (<any>this)._processedPetsForReceipt = [];
            }

            return 1
        } catch (err) {
            console.error('saveInvoiceReceiptInfo error', err);
            // clear any temporary arrays to avoid leaking state
            (<any>this)._receiptsToSetup = [];
            (<any>this)._processedPetsForReceipt = [];
            return 0
        }
    }

    getPaymentInfo(pet_no) {
        const vpet = this.payment_Details_list.find(pet => pet.pet_no == pet_no);
        return vpet;
    }

    async printInvoiceReceipt(clinic_no, client_no, invoice_no) {
        let $string = `admin` + "U*63r" + 'FPC_InvoiceReceipt' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Invoice Receipt.. ${new Date().getTime()}` + "T1*73";
        let $result = encode_utf8($string);
        $result = encode_base64($result);
        let $strfilter = `&clinic_no=${clinic_no}&client_no=${client_no}&invoice_no=${invoice_no}&pet_no=0`;
        let url = `token=${$result}${$strfilter}`;
        const fileId = await this.DownloadSaveReport(url, 'InvoiceReceipt(' + client_no + ')_' + new Date().getTime(), client_no, 0);

        return fileId;
    }

    DownloadSaveReport(queryString: string, reportName: string, client_no: number, pet_no: number) {
        const requestBody = {
            queryString: queryString,
            reportName: reportName,
            client_no: client_no,
            pet_no: pet_no
        };

        let promise = new Promise((resolve, reject) => {
            this.api.post(`report/DownloadReport`, requestBody).subscribe((res: any) => {
                if (res && res.success) {

                    if(this.emailInvReciept = true){
                        this.emailToClient(res.fileData, res.fileName || `${reportName}.pdf`)
                    } 

                    // Convert base64 to blob and download 
                    const byteCharacters = atob(res.fileData);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });

                    // Create download link
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = res.fileName || `${reportName}.pdf`;
                    document.body.appendChild(link);
                    link.click();

                    // Clean up
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    resolve(res.fileId); // Return the fileId from the response
                } else {
                    resolve(0);
                }
            }, (error) => {
                reject(error);
            });
        });

        return promise;
    }

    async emailToClient(filedata: string, fileName: string){ 
        this.emailService.sendEmailWithReport('info@familypetcare.com', [this.clientService.client.email_address], 'Invoice Receipt for ' + this.pet_data.pet_name , 'Please find attached the invoice receipt for ' + this.pet_data.pet_name + '.', { fileName: fileName, contentType: 'application/pdf', data: filedata })
    }

    //#endregion


    //#region JP MORGAN

    create_JPMPaymentLink(items: any, amount: number, client_no: any) {
        let dta = {
            items: items,
            amount: amount,
            client_no: client_no
        }
        let promise = new Promise((resolve, reject) => {
            this.api.post(`payment/createpaymentlink`, dta)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    //#endregion

    creupPetNote(pet_no?: number, note_text?: string, note_type?: number) {
        this.pet_note.pet_no = pet_no;
        this.pet_note.note_text = note_text;
        this.pet_note.note_type = note_type;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`pet/SetupPetNote`, this.pet_note)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupNote() {
        let promise = new Promise((resolve, reject) => {
            this.api.post<string>(`pet/SetupNote`, this.note)
                .subscribe((res: any) => {
                    resolve(res);
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    // UpdateInvoiceReceiptFileId(int invoice_no, int file_id)
    updateInvoiceReceiptFileId(invoice_no: number, file_id: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post<string>(`invoice/UpdateInvoiceReceiptFileId?invoice_no=${invoice_no}&file_id=${file_id}`)
                .subscribe((res: any) => {
                    resolve(res);
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }




    //#region Put Into History 
    PutIntoHistory(trans_item: any) {
        console.log('PutIntoHistory-invoice_trans', trans_item)
        console.log('Is Array?', Array.isArray(trans_item))

        // Handle case where trans_item is an array
        const item = Array.isArray(trans_item) ? trans_item[0] : trans_item;
        console.log('Extracted item:', item)

        console.log('sup_sequence:', item.sup_sequence, 'status:', item.status)

        if (item.sup_sequence == 0) {
            console.log('sup_sequence is 0, checking status...')
            if (item.status == 'D' || item.status == 'F' || item.status == 'O') {
                console.log('PTH-1', item)
                this.iMoveToHistoryParent(item)
            } else {
                console.log('Status not D/F/O, status is:', item.status)
            }
        }
        else if (item.status == 'S') {
            console.log('PTH-3', item)
            this.iMoveToSuggested(item)
        } else {
            console.log('No conditions met - sup_sequence:', item.sup_sequence, 'status:', item.status)
        }
    }

    iMoveToHistoryParent(tran): Promise<boolean> {
        return new Promise<boolean>(async (resolve) => {
            if (tran.moved == 1) {
                resolve(true)
            }

            const lngHistSeq = await this.iMoveToHistoryProc(tran, 0)
            if (lngHistSeq != 0) {
                tran.moved = 1

                this.UpdateTransMoved(tran.tran_sequence)

                if (tran.code_name == 'EUTH') {
                    if (this.userData.clinic_no == 1) {
                        this.UpdateEuthToInactive(tran.pet_no)
                    }
                }

                this.iUpdateBriefHist(tran)
                this.iMoveToDrugNote(tran)
                this.iMoveToHistoryChild(tran, lngHistSeq)

                let strSubCat = await this.GetItemCategory(1459, 0, 1).then((res: any) => { return res.code_sub_category })
                if (strSubCat == 'O-LAB') {
                    this.InsertLabTran(lngHistSeq, tran.pet_no, tran.code_clinic, tran.done_date, tran.link_no, tran.link_type, tran.appr_by)
                }

                this.iMoveSubTran(tran.tran_sequence, lngHistSeq)
                resolve(true)
            }
            else {
                resolve(false)
            }
        })
    }

    iMoveToHistoryProc(tran, lngSupSeq): Promise<number> {


        this.inv_history = new InvHistoryModel(0, lngSupSeq, this.inv_otherdata.lngInvNo, tran.pet_no, this.userData.clinic_no, tran.done_date, tran.appr_date, this.getCurrentDateTime(), tran.link_no, tran.link_type, tran.cost, tran.unit, tran.response1, tran.response2, tran.req_by, tran.done_by, tran.appr_by, this.userData.client_no, tran.route, 0, tran.location, this.userData.client_no)
        if (lngSupSeq == 0) {
            this.inv_history.display = 1
        }
        else {
            this.inv_history.display = tran.pstatus
        }

        console.log(this.inv_history)
        return this.SetupInvHistory().then((res: number) => {
            return res
        })
    }

    async iUpdateBriefHist(tran) {
        const res = await this.GetBriefHistoryCategory(tran.link_no, tran.link_type, tran.code_clinic);
        if (res === '') {
            console.log('exited')
            return false; // Exit the function
        }

        this.UpdateBriefHist(tran.pet_no, tran.link_no, tran.link_type, tran.code_clinic, tran.client_no, tran.code_name,
            tran.done_date, tran.response1, tran.response2)
    }

    async iMoveToDrugNote(tran) {
        const res: any = await this.GetTempPrescBySeq(tran.tran_sequence);
        let blnIsRefill = false
        let strTemp = ''

        if (res.pet_no == 0) {
            console.log('empty res exit')
            return false; // Exit the function 
        }

        if (res.pet_no != 0) {
            this.SetupMoveToDrugNote(tran.tran_sequence, tran.done_date)
            blnIsRefill = false
        }

        if (!blnIsRefill) {
            strTemp = res.product_name
        }
        else {
            strTemp = tran.code_name
        }

        this.InsertToDrugNote(res.pet_no, tran.done_date, strTemp, res.doctor, res.units, res.package,
            res.refill_count, res.refill_expire, res.allow_generic, res.instructions, res.in_clinic, res.use_for, tran.unit)

    }

    async iMoveToHistoryChild(tran, lngHistSeq) {
        let tmptran: any = await this.GetTmpInvoiceTrans(tran.tran_sequence)

        if (!tmptran) {
            return false;
        }

        tmptran.sup_sequence = lngHistSeq

        tmptran.forEach(async (item) => {
            if (item.status != 'S') {
                const lngSupSeq = await this.iMoveToHistoryProc(item, lngHistSeq)
                if (lngSupSeq != 0) {

                    this.UpdateTransMoved(item.cod)

                    const code = this.catalogService.codes_file.find(codes => codes.code_no === item.link_no);

                    if (code.code_name == 'EUTH') {
                        if (this.userData.clinic_no == 1) {
                            this.UpdateEuthToInactive(item.pet_no)
                        }
                    }

                    item.sup_sequence = lngSupSeq
                    this.iUpdateBriefHist(item)
                    this.iMoveSubTran(item.tran_sequence, lngSupSeq)

                }
            }
        })
    }

    iMoveSubTran(tran_seq, sup_seq) {
        this.GetInvSubTran(tran_seq).then((item: any) => {
            if (item) {
                item.forEach((subtran) => {
                    this.InsertSubTran(sup_seq, subtran.sub_tran_link_no, subtran.sub_tran_link_type, subtran.sub_tran_unit)
                })
            }
        })
    }

    iMoveToSuggested(tran) {
        const code = this.catalogService.codes_file.find(codes => codes.code_no === tran.link_no);
        const vnote_text = "Suggested, but declined: " + code.procedure_desc + " (" + tran.code_name + ").     -- " + tran.req_by
        this.MoveToSuggested(tran.pet_no, tran.req_date, tran.link_no, tran.link_type, tran.tran_sequence, tran.req_date, vnote_text)
    }

    //#endregion

}